// extracted by mini-css-extract-plugin
export var avatar = "_o1-3";
export var avatarContainer = "_o1-2";
export var avatarSpacer = "_o1-5";
export var avatarSpacerContainer = "_o1-4";
export var avatarStackContainer = "_o1-1";
export var bubble = "_o1-0";
export var remainderBubble = "_o1-6";